@import "../../variables.scss";

.autocomplete {
  &__wrapper {
    position: relative;
    width: 280px;
  }
  &__viewAll {
    position: sticky;
    bottom: 0;
    font-weight: bold;
    color: black;
    background-color: #e5e5e5;
    width: 100%;
    height: 40px;
    padding-left: 16px;
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover {
      color: black;
    }
  }
  &__items {
    list-style-type: none;
    width: 100%;
    border-radius: 4px;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);
    padding: 0;
    position: absolute;
    background-color: white;
    overflow-y: auto;
    max-height: 240px;
  }
  &__searchbox {
    width: 100%;
  }
  &__listing {
    white-space: nowrap;
    cursor: pointer;
    padding: 8px 16px;
    display: flex;
    flex-direction: column;
    &:hover {
      background-color: $color-transparent-grey;
      text-decoration: none;
    }
    &_title {
      font-family: Lato;
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 19px;
      white-space: nowrap;
      width: 100%;
      text-overflow: ellipsis;
      display: block;
      overflow: hidden;
      color: black;
      text-decoration: none;
    }
    &_subtitle {
      color: #666666;
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
      letter-spacing: 0.23px;
      line-height: 12px;
    }
  }
  &__empty {
    &_wrapper {
      padding-top: 16px;
    }
    &_title {
      color: black;
      font-family: Lato;
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 0.3px;
      line-height: 20px;
      text-align: center;
    }
    &_value {
      color: $color-light-grey;
      font-family: Lato;
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 0.3px;
      line-height: 20px;
      text-align: center;
    }
    &_footer {
      color: black;
      font-family: Lato;
      font-size: 12px;
      letter-spacing: 0.23px;
      line-height: 28px;
      text-align: center;
    }
  }
}
